const deutsch = {
    'BOOKED_SUBCONTRACTORS.Title': 'Gebuchte Subunternehmer',
    'BOOKED_SUBCONTRACTORS.Add': 'Subunternehmer zur Messe hinzufügen',
    'BOOKED_SUBCONTRACTORS.Company': 'Unternehmen',
    'BOOKED_SUBCONTRACTORS.Booked': 'Gebuchte Mitarbeiter',
    'BOOKED_SUBCONTRACTORS.Registered': 'Angemeldete Mitarbeiter',
    'BOOKED_SUBCONTRACTORS.OverBooked': '{count} mehr als gebucht',
    'BOOKED_SUBCONTRACTORS.Actions': 'Aktionen',
    'BOOKED_SUBCONTRACTORS.Edit': 'Bearbeiten',
    'BOOKED_SUBCONTRACTORS.Delete': 'Buchung entfernen',
    'BOOKED_SUBCONTRACTORS.EditTitle': 'Gebuchte Mitarbeiter bearbeiten',
    'BOOKED_SUBCONTRACTORS.DeleteTitle': 'Subunternehmerbuchung entfernen?',
    'BOOKED_SUBCONTRACTORS.DeleteDescription': 'Nur diese Buchung wird entfernt. Das Unternehmen und seine zugewiesenen Mitarbeiter bleiben unverändert.',
    'BOOKED_SUBCONTRACTORS.RegisteredScopeHint': 'Angemeldete Mitarbeiter: nur { monteure } und { sub_teamleader } des Unternehmens, die dieser Messe zugewiesen sind.',
    'BOOKED_SUBCONTRACTORS.RegisteredScopeLoading': 'Namen der angemeldeten Mitarbeitergruppen werden geladen…',
    'BOOKED_SUBCONTRACTORS.RegisteredScopeUnavailable': 'Namen der angemeldeten Mitarbeitergruppen sind nicht verfügbar.',
    'BOOKED_SUBCONTRACTORS.Description': 'Grün bedeutet: gebucht und angemeldet stimmen überein. Rot zeigt fehlende oder zusätzliche Mitarbeiter.',
    'BOOKED_SUBCONTRACTORS.QuantityHint': 'Bei null bleibt das Unternehmen in dieser Liste. Eine Mengenänderung ändert keine Mitarbeiterzuweisungen.',
    'BOOKED_SUBCONTRACTORS.Save': 'Speichern',
    'BOOKED_SUBCONTRACTORS.Cancel': 'Abbrechen',
    'BOOKED_SUBCONTRACTORS.Retry': 'Erneut versuchen',
    'BOOKED_SUBCONTRACTORS.LoadMore': 'Weitere Unternehmen laden',
    'BOOKED_SUBCONTRACTORS.ChooseCompany': 'Subunternehmen auswählen',
    'BOOKED_SUBCONTRACTORS.NoCompanies': 'Keine Unternehmen gefunden',
    'BOOKED_SUBCONTRACTORS.Empty': 'Für diese Messe sind noch keine Subunternehmer gebucht.',
    'BOOKED_SUBCONTRACTORS.Unavailable': 'Nicht verfügbar',
    'BOOKED_SUBCONTRACTORS.LoadFailed': 'Buchungen konnten nicht geladen werden. Bitte versuchen Sie es erneut.',
    'BOOKED_SUBCONTRACTORS.CompanyLoadFailed': 'Unternehmen konnten nicht geladen werden.',
    'BOOKED_SUBCONTRACTORS.SaveFailed': 'Die Buchung konnte nicht gespeichert werden. Bitte versuchen Sie es erneut.',
    'BOOKED_SUBCONTRACTORS.SavedRefreshFailed': 'Die Änderung wurde gespeichert, aber die aktuelle Liste konnte nicht geladen werden. Laden Sie die Liste erneut, bevor Sie weitere Änderungen vornehmen.',
    'BOOKED_SUBCONTRACTORS.Saved': 'Buchung gespeichert',
    'BOOKED_SUBCONTRACTORS.Deleted': 'Buchung entfernt',
    'BOOKED_SUBCONTRACTORS.InvalidQuantity': 'Geben Sie eine ganze Zahl ab 0 ein.',
    'BOOKED_SUBCONTRACTORS.NeedsRefresh': 'Die Buchungsliste wurde geändert oder ist nicht verfügbar. Laden Sie die aktuelle Liste, bevor Sie weitere Änderungen vornehmen.',
    'BOOKED_SUBCONTRACTORS.UnconfirmedChange': 'Das Ergebnis konnte nicht bestätigt werden. Laden Sie die aktuelle Liste, bevor Sie weitere Änderungen vornehmen.',
    'BOOKED_SUBCONTRACTORS.DeleteUnconfirmed': 'Die Löschung konnte nicht bestätigt werden. Laden Sie die Liste erneut, um das Ergebnis zu prüfen.',
    'BOOKED_SUBCONTRACTORS.DuplicateCompany': 'Für dieses Unternehmen besteht bereits eine Buchung für diese Messe.',
    'BOOKED_SUBCONTRACTORS.NoEditPermission': 'Sie haben keine Berechtigung, Messebuchungen zu ändern.',
    'BOOKED_SUBCONTRACTORS.RequestPending': 'Bitte warten Sie, bis die laufende Anfrage abgeschlossen ist.',
    'USER.Button_Text_Create': 'Benutzer erstellen',
    'USER.Button_Text_Delete': 'Benutzer löschen',
    'GROUP.Button_Text_Create': 'Gruppe erstellen',
    'GROUP.Button_Text_Delete': 'Gruppe löschen',
    'LANGUAGE.Button_Text_Create': 'Sprache erstellen',
    'LANGUAGE.Button_Text_Delete': 'Sprache löschen',
    'SUBCONTRACTOR.Button_Text_Create': 'Subunternehmer erstellen',
    'SUBCONTRACTOR.Button_Text_Delete': 'Subunternehmer löschen',
    'SUBCONTRACTOR.Button_Text_Import': 'Subunternehmer importieren',
    'STAND.Button_Text_Create': 'Stand erstellen',
    'STAND.Button_Text_Delete': 'Stand löschen',
    'EXHIBITION.Button_Text_Create': 'Veranstaltung erstellen',
    'EXHIBITION.Button_Text_Delete': 'Veranstaltung löschen',
    'EXHIBITION.Button_Text_Import': 'Veranstaltung importieren',
    'JOB.Button_Text_Create': 'Job erstellen',
    'JOB.Button_Text_Add': 'Job hinzufügen',
    'JOB.Type_Text_Claim': 'MP Reklamation',
    'JOB.Type_Text_CustomerClaim': 'Kunden Reklamation',
    'JOB.Type_Text_LastMinute': 'Lastminute',
    'JOB.Type_Text_Damage': 'Schaden',
    'JOB.Type_Text_ProtocolDefect': 'Mangel',
    'JOB.Status_Text_Open': 'Offen',
    'JOB.Status_Text_InProgress': 'In Bearbeitung',
    'JOB.Status_Text_Completed': 'Fertiggestellt',
    'HALL.Button_Text_Create': 'Halle erstellen',
    'HALL.Button_Text_Delete': 'Halle löschen',
    'FURNISHING.Button_Text_AddFurnishing': 'Ausstattung hinzufügen',
    'FURNISHING.Button_Text_FurnishingImport': 'AUSSTATTUNG IMPORT',
    'CRAFT.Button_Text_AddCraft': 'Gewerk hinzufügen',
    'CRAFT.Button_Text_CreateCraft': 'Gewerk anlegen',
    'GRAPHIC_PACKING.Button_Text_Create': 'Neue Bereitstellung anlegen',
    'GRAPHIC_STAND.Button_Text_Create': 'Grafik bereitstellen',
    'TABLES.Column_Title_Name': 'Name',
    'TABLES.Column_Title_Phone': 'Telefon',
    'TABLES.Column_Title_Email': 'E-Mail',
    'TABLES.Column_Title_Company': 'Firma',
    'TABLES.Column_Title_UserGroup': 'Benutzergruppe',
    'TABLES.Column_Title_User': 'Benutzer',
    'TABLES.Column_Title_Exhibition': 'Veranstaltung',
    'TABLES.Column_Title_Time': 'Zeit',
    'TABLES.Column_Title_Hall': 'Halle',
    'TABLES.Column_Title_HallNew': 'Halle neu',
    'TABLES.Column_Title_BlockNew': 'Block neu',
    'TABLES.Column_Title_StandNew': 'Stand neu',
    'TABLES.Column_Title_Halls': 'Hallen',
    'TABLES.Column_Title_Comments': 'Kommentare',
    'TABLES.Column_Title_DamageFilesCount': 'Schadensdateien',
    'TABLES.Column_Title_StandNumber': 'Stand-Nr.',
    'TABLES.Column_Title_Craft': 'Gewerk',
    'TABLES.Column_Title_Crafts': 'Gewerke',
    'TABLES.Column_Title_JobNumber': 'Job-Nr.',
    'TABLES.Column_Title_Jobs': 'Jobs',
    'TABLES.Column_Title_JobTableNumber': 'Nummer',
    'TABLES.Column_Title_CadNumber': 'CAD-Nr.',
    'TABLES.Column_Title_JobType': 'Jobtyp',
    'TABLES.Column_Title_Type': 'Typ',
    'TABLES.Column_Title_Message': 'Mitteilung',
    'TABLES.Column_Title_Label': 'Etikett',
    'TABLES.Column_Title_Slug': 'Slug',
    'TABLES.Column_Title_GroupRights': 'Gruppenrechte',
    'TABLES.Column_Title_NumberUsers': 'User Anzahl',
    'TABLES.Column_Title_NumberStands': 'Anzahl Stände',
    'TABLES.Column_Title_Stands': 'Stände',
    'TABLES.Column_Title_Title': 'Name',
    'TABLES.Column_Title_HallNumber': 'Hallennummer',
    'TABLES.Column_Title_Number': 'Kreditornummer',
    'TABLES.Column_Title_Exhibitor': 'Aussteller',
    'TABLES.Column_Title_ExhibitionName': 'Veranstaltungsname',
    'TABLES.Column_Title_ExhibitionEvent': 'Veranstaltung',
    'TABLES.Column_Title_AcquiseNumber': 'AKQ',
    'TABLES.Column_Title_ProaufNumber': 'PROAUF',
    'TABLES.Column_Title_HallName': 'Halle',
    'TABLES.Column_Title_Corridor': 'Gang',
    'TABLES.Column_Title_CorridorNew': 'Gang Neu',
    'TABLES.Column_Title_Block': 'Block',
    'TABLES.Column_Title_DeliveryTime': 'Deadline',
    'TABLES.Column_Title_Materials': 'Anhänge',
    'TABLES.Column_Title_Actions': 'Aktionen',
    'TABLES.Column_Title_Status': 'Status',
    'TABLES.Column_Title_Description': 'Beschreibung',
    'TABLES.Column_Title_Created': 'Erstellt',
    'TABLES.Column_Title_InProgress': 'in Bearbeitung',
    'TABLES.Column_Title_Completed': 'Fertiggestellt',
    'TABLES.Column_Title_Attachments': 'Anhänge',
    'TABLES.Column_Title_Acqusition': 'AKQ Nr.',
    'TABLES.Column_Title_HallPlan': 'Hallenplan',
    'TABLES.Column_Title_ConstractionStarts': 'Aufbaubeginn',
    'TABLES.Column_Title_ConstractionEnds': 'Aufbauende',
    'TABLES.Column_Title_EventStarts': 'Veranstaltungsbeginn',
    'TABLES.Column_Title_Dismantling': 'Abbau',
    'TABLES.Column_Title_ElfeOnline': 'ELFE online Status',
    'TABLES.Column_Title_TimeCompletion': 'Deadline',
    'TABLES.Column_Title_Subcontractor': 'Subunternehmer',
    'TABLES.Column_Title_ID': 'ID',
    'TABLES.Column_Sorting_Tooltip_Ascending': 'Aufsteigend sortieren',
    'TABLES.Column_Sorting_Tooltip_Descending': 'Absteigend sortieren',
    'TABLES.Column_Sorting_Tooltip_Cancel': 'Sortierung abbrechen',
    'TABLES.Column_Title_FileName': 'Dateiname',
    'TABLES.Column_Title_FurnishingDescription': 'Artikelbezeichnung',
    'TABLES.Column_Title_Sku': 'Artikelnummer',
    'TABLES.Column_Title_Image': 'Foto',
    'TABLES.Column_Title_LastMinutePrice': 'Last Minute Preis',
    'TABLES.Column_Title_Quantity': 'verfügbare Menge',
    'TABLES.Column_Title_ShelfNumber': 'Regal Nr.',
    'TABLES.Column_Title_Shelf': 'Regal',
    'TABLES.Column_Title_ShelfUser': 'Eingel. von',
    'TABLES.Column_Title_ShelfDate': 'Einlag. Datum',
    'TABLES.Column_Title_GraphicMiss': 'Status',
    'TABLES.Column_Title_Date': 'Datum',
    'TABLES.Column_Title_PackedBy': 'Verpackt von',
    'TABLES.Column_Title_GraphicStandShelfNumber': 'Lager Regal Nr.',
    'TABLES.Column_Title_Outsourced': 'Ausgelagert',
    'TABLES.Column_Title_ReturnWarehouse': 'zurück ins Grafiklager',
    'TABLES.Column_Title_Comment': 'Kommentar',
    'TABLES.Column_Title_GraphicAmount': 'Grafik Anzahl',
    'TABLES.Column_Title_GraphicStorage': 'Grafik Einlagerung',
    'TABLES.Column_Title_Requests': 'Anfragen',
    'TABLES.Column_Title_Items': 'Verarbeitete Elemente',
    'TABLES.Column_Title_PromptTokens': 'Eingabe-Tokens',
    'TABLES.Column_Title_CompletionTokens': 'Ausgabe-Tokens',
    'TABLES.Column_Title_TotalTokens': 'Tokens gesamt',
    'TABLES.Column_Title_TotalPrice': 'Gesamtkosten',
    'TABLES.Column_Title_Model': 'Modell',
    'TABLES.Column_Title_SourceLanguage': 'Ausgangssprache',
    'TABLES.Column_Title_TargetLanguage': 'Zielsprache',
    'TABLES.Column_Title_LastRequest': 'Letzte Anfrage',
    'TABLES.Title_RequestBatchLog': 'Anfrageprotokoll',
    'TABLES.Description_RequestBatchLog': 'Jede Zeile ist ein Übersetzungs-Batch für Jobs oder Kommentare. UI-Label-Übersetzungen sind ausgeschlossen.',
    'TABLES.Value_FromCache': 'Aus Cache',
    'TABLES.Value_Free': 'Kostenlos',
    'TABLES.Tooltip_Tokens': 'Eingabe-Tokens plus Ausgabe-Tokens aus Übersetzungsanfragen für Jobs oder Kommentare.',
    'TABLES.Tooltip_Items': 'Verarbeitete Job-/Kommentartexte in Übersetzungsanfragen.',
    'TABLES.Tooltip_Cost': 'Kosten basieren auf Provider-Tarifen und Token-Nutzung.',
    'TABLES.Tooltip_EstimatedCost': 'Aus Token-Nutzung und Modellpreisen geschätzt.',
    'TABLES.Chart_Title_RequestsByDay': 'Anfragen pro Tag',
    'TABLES.Chart_Title_TokenVolume': 'Tokenvolumen',
    'TABLES.Chart_Title_CostTrend': 'Kostenverlauf',
    'TABLES.Chart_Title_RequestsByModel': 'Anfragen pro Modell',
    'TABLES.Chart_Title_TargetLanguages': 'Zielsprachen',
    'TABLES.Chart_Title_CostByModel': 'Kosten pro Modell',
    'TABLES.Chart_Description_RequestsByDay': 'Tägliche Anzahl der Übersetzungsanfragen für Jobs oder Kommentare.',
    'TABLES.Chart_Description_TokenVolume': 'Eingabe- und Ausgabe-Tokens der Job-/Kommentarübersetzungen.',
    'TABLES.Chart_Description_CostTrend': 'Kosten der Job-/Kommentarübersetzungen über die Zeit.',
    'TABLES.Chart_Description_RequestsByModel': 'Job-/Kommentarübersetzungen pro AI-Modell für die aktuellen Filter.',
    'TABLES.Chart_Description_TargetLanguages': 'Zeigt bis zu 20 Zielsprachen für die aktuellen Job-/Kommentar-Anfrageergebnisse.',
    'TABLES.Chart_Description_CostByModel': 'Kosten der Job-/Kommentarübersetzungen pro Modell für die aktuellen Filter.',
    'FORM_RULES.Min_NewPassword': 'Ihr Passwort muss mindestens { minLength } Zeichen enthalten.',
    'FORM_RULES.Required_NewPassword': 'Neues Passwort eingeben.',
    'FORM_RULES.Required_ConfirmPassword': 'Neues Passwort bestätigen.',
    'FORM_RULES.Required_ConfirmPasswordMatch': 'Die eingegebenen Passwörter stimmen nicht überein.',
    'FORM_RULES.Required_Name': 'Vornamen eingeben.',
    'FORM_RULES.Required_Surname': 'Nachnamen eingeben.',
    'FORM_RULES.Required_Email': 'Die eingegebene E-Mail-Adresse ist ungültig.',
    'FORM_RULES.Required_Choose': 'Bitte auswählen',
    'FORM_RULES.Required_Phone': 'Telefonnummer eingeben',
    'FORM_RULES.Required_GroupName': 'Gruppennamen eingeben',
    'FORM_RULES.Required_LanguageLabel': 'Sprachbezeichnung eingeben',
    'FORM_RULES.Required_LanguageSlug': 'Sprach-Slug eingeben',
    'FORM_RULES.Required_Title': 'Titel eingeben',
    'FORM_RULES.Required_Number': 'Nummer eingeben',
    'FORM_RULES.Required_Where': 'Bitte auswählen',
    'FORM_RULES.Required_DeliveryTime': 'Deadline festlegen',
    'FORM_RULES.Required_Exhibitor': 'Austellernamen eingeben',
    'FORM_RULES.Required_ProafNumber': 'PROAUF eingeben',
    'FORM_RULES.Required_StandNumber': 'Standnummer eingeben',
    'FORM_RULES.Required_CadNumber': 'Job fertiggestellt',
    'FORM_RULES.Required_KeyName': 'Schlüsselnamen eingeben',
    'FORM_RULES.Required_KeyNumber': 'Schlüsselnummer eingeben',
    'FORM_RULES.Required_HallName': 'Bitte eingeben',
    'FORM_RULES.Required_HallNumber': 'Bitte eingeben',
    'FORM_RULES.Required_Password': 'Passwort eingeben',
    'FORMS.Input_Label_FurnishingDescr': 'Artikelbezeichnung',
    'FORMS.Input_Label_Sku': 'Artikelnummer',
    'FORMS.Input_Label_LastMinutePrice': 'Last Minute Preis',
    'FORMS.Input_Label_LastMinuteQuantity': 'Menge',
    'FORMS.Input_Label_Password': 'Passwort',
    'FORMS.Input_Label_Login': 'Login',
    'FORMS.Input_Label_NewPassword': 'Neues Passwort',
    'FORMS.Input_Label_ConfirmPassword': 'Neues Passwort bestätigen',
    'FORMS.Input_Label_Language': 'Sprache',
    'FORMS.Input_Label_LanguageLabel': 'Sprachbezeichnung',
    'FORMS.Input_Label_LanguageSlug': 'Sprach-Slug',
    'FORMS.Input_Label_Craft': 'Gewerk',
    'FORMS.Input_Label_CraftType': 'Gewerketyp',
    'FORMS.Input_Label_CraftTitle': 'Gewerkename',
    'FORMS.Input_Label_TimeOfCompletion': 'Deadline',
    'FORMS.Input_Label_Name': 'Vorname',
    'FORMS.Input_Label_Surname': 'Nachname',
    'FORMS.Input_Label_Phone': 'Telefonnummer (Login)',
    'FORMS.Input_Label_Email': 'E-Mail',
    'FORMS.Input_Label_UsersGroup': 'Usergruppe',
    'FORMS.Input_Label_GroupName': 'Gruppenname',
    'FORMS.Input_Label_GroupColor': 'Gruppenfarbe',
    'FORMS.Input_Label_CrmRights': 'CRM Userrechte',
    'FORMS.Input_Label_SubRights': 'SUB Userrechte',
    'FORMS.Input_Label_Attachment': 'Anhang',
    'FORMS.Input_Label_HallPlan': 'Hallenplan',
    'FORMS.Input_Label_AppRights': 'ELFE App Userrechte',
    'FORMS.Input_Label_Subcontractor': 'Subunternehmer',
    'FORMS.Input_Label_AssignedExhibitions': 'Zugewiesene Veranstaltungen',
    'FORMS.Input_Label_Title': 'Name',
    'FORMS.Input_Label_Number': 'Kreditornummer',
    'FORMS.Input_Label_Where': 'Ort',
    'FORMS.Input_Label_Hall': 'Halle',
    'FORMS.Input_Label_NewDeliveryTime': 'Neue Deadline',
    'FORMS.Input_Label_Exhibitor': 'Ausstellername',
    'FORMS.Input_Label_AcqstnNumber': 'AKQ-Nr.',
    'FORMS.Input_Label_ProaufNumber': 'PROAUF-Nr.',
    'FORMS.Input_Label_Proauf': 'PROAUF',
    'FORMS.Input_Label_Block': 'Block',
    'FORMS.Input_Label_Corridor': 'Gang',
    'FORMS.Input_Label_Stand': 'Stand',
    'FORMS.Input_Label_StandNum': 'Stand-Nr.',
    'FORMS.Input_Label_StandNumber': 'Standnummer',
    'FORMS.Input_Label_CadNumber': 'CAD-Nummer',
    'FORMS.Input_Label_Time': 'Zeit',
    'FORMS.Input_Label_DeliveryTime': 'Deadline',
    'FORMS.Input_Label_Acquisition': 'Akquisition',
    'FORMS.Input_Label_KeyName': 'Schlüssel für',
    'FORMS.Input_Label_Key': 'Schlüsselnummer',
    'FORMS.Input_Label_JobType': 'Jobtyp',
    'FORMS.Input_Label_JobStatus': 'Jobstatus',
    'FORMS.Input_Label_JobNum': 'Job-Nr.',
    'FORMS.Input_Label_Exhibition': 'Veranstaltung',
    'FORMS.Input_Label_ExhibitionName': 'Veranstaltungsname',
    'FORMS.Input_Label_ExhibitionStarts': 'Veranstaltungsbeginn',
    'FORMS.Input_Label_ExhibitionEnds': 'Veranstaltungsende',
    'FORMS.Input_Label_ElfeOnline': 'Veranstaltung ist Online',
    'FORMS.Input_Label_ConstructionStarts': 'Aufbaubeginn',
    'FORMS.Input_Label_ConstructionEnds': 'Aufbauende',
    'FORMS.Input_Label_DismantlingStarts': 'Abbaubeginn',
    'FORMS.Input_Label_DismantlingEnds': 'Abbauende',
    'FORMS.Input_Label_ExhibitionLink': 'Veranstaltungslink',
    'FORMS.Input_Label_ExhibitionEvent': 'Veranstaltung',
    'FORMS.Input_Label_Description': 'Beschreibung',
    'FORMS.Input_Label_ChooseType': 'Typ wählen',
    'FORMS.Input_Label_Status': 'Status',
    'FORMS.Input_Label_ChooseStatus': 'Status wählen',
    'FORMS.Input_Label_HallName': 'Hallenbezeichnung',
    'FORMS.Input_Label_HallNumber': 'Hallennummer',
    'FORMS.Input_Label_HallToMoveStandsTo': 'Stände in Halle verschieben',
    'FORMS.Input_Label_Company': 'Firma',
    'FORMS.Input_Label_NewFinishingTime': 'Neue Deadline festlegen',
    'FORMS.Input_Label_ShelfNumber': 'Regal Nr.',
    'FORMS.Input_Label_GraphicStandShelfNumber': 'Lager Regal Nr.',
    'FORMS.Input_Label_CompletedAt': 'Fertiggestellt am',
    'FORMS.Input_Label_CraftTypeIcon': 'Gewerk-Icon',
    'FORMS.Input_Label_CraftCustomIcon': 'Custom-Icon',
    'FORMS.Input_Label_Model': 'Modell',
    'FORMS.Input_Label_SourceLanguage': 'Ausgangssprache',
    'FORMS.Input_Label_TargetLanguage': 'Zielsprache',
    'FORMS.Input_Label_CheckLatitude': 'Latitude',
    'FORMS.Input_Label_CheckLongitude': 'Longitude',
    'FORMS.Input_Label_CheckRadius': 'Radius in Metern',
    'FORMS.Validation_CheckRadiusRange': 'Der Radius muss zwischen 1 und 75 Metern liegen.',
    'FORMS.Input_Label_CheckLocationCountry': 'Land',
    'FORMS.Input_Label_CheckLocationSearch': 'Adresse oder Veranstaltungsort',
    'FORMS.Title_ChangePassword': 'Passwort ändern',
    'FORMS.Title_SendPassword': 'Passwort versenden',
    'FORMS.Title_AddUsers': 'Benutzer hinzufügen',
    'FORMS.Title_SelectStand': 'Stand auswählen',
    'FORMS.Title_CopyFromEvent': 'Aus Veranstaltung kopieren',
    'MODAL.Button_Text_CopyFromEvent': 'Aus veranstaltung kopieren',
    'FORMS.Title_AddSubcontractor': 'Subunternehmer hinzufügen',
    'FORMS.Title_AssignSubcontractors': 'Subunternehmer zuweisen',
    'FORMS.Title_ChooseSubcontractor': 'Subunternehmer auswählen',
    'FORMS.Title_ChooseType': 'Wähle den Typ',
    'FORMS.Title_AddExhibitions': 'Veranstaltung hinzufügen',
    'FORMS.Title_DeliveryTime': 'Deadline ändern',
    'FORMS.Title_CraftTime': 'Gewerke Deadline ändern',
    'FORMS.Title_CraftDone': 'Gewerk fertiggestellt',
    'FORMS.Title_CraftInProcess': 'Gewerk in Bearbeitung',
    'FORMS.Title_CraftAdditional': 'Zusätzliches Gewerk erstellen',
    'FORMS.Title_CraftAdditionalEdit': 'Zusätzliches Gewerk bearbeiten',
    'FORMS.Title_CraftDelete': 'Gewerk löschen',
    'FORMS.Title_CreateLastMinJob': 'Last-Minute-Job erstellen',
    'FORMS.Title_DeleteHall': 'Halle löschen',
    'FORMS.Title_EditJob': 'Auftrag bearbeiten',
    'FORMS.Title_EditFurnishing': 'LH Ausstattung bearbeiten',
    'FORMS.Title_AddFurnishing': 'Ausstattung hinzufügen',
    'FORMS.Title_EditCraft': 'Gewerk bearbeiten',
    'FORMS.Title_CreateCraft': 'Gewerk erstellen',
    'FORMS.Title_Text_Filters': 'Filter',
    'FORMS.Title_Text_CreateJob': 'Job erstellen',
    'FORMS.Title_AddFile': 'Datei hinzuzufügen',
    'FORMS.Title_EditFile': 'Datei bearbeiten',
    'FORMS.Title_AddPrint': 'Grafik einlagern',
    'FORMS.Title_AddComment': 'Kommentar hinzufügen',
    'FORMS.Title_EditComment': 'Kommentar bearbeiten',
    'FORMS.Title_SelectGraphicStand': 'Aussteller auswählen',
    'FORMS.Title_ChooseShelf': 'Freies Regal wählen',
    'FORMS.Select_OptionLabel_English': 'Englisch',
    'FORMS.Select_OptionLabel_Deutsch': 'Deutsch',
    'FORMS.Select_OptionLabel_ChooseColor': 'Farbe wählen',
    'FORMS.Select_OptionLabel_SelectedStands': 'in den ausgewählten Ständen ({ length })',
    'FORMS.Select_OptionLabel_AllStandsHall': 'Alle Stände der Halle',
    'FORMS.Select_OptionLabel_AllStandsExhibition': 'Alle Stände der Veranstaltung',
    'FORMS.Select_OptionLabel_HallNotSelected': 'Halle nicht ausgewählt',
    'FORMS.Select_OptionLabel_Completed': 'Fertiggestellt',
    'FORMS.Select_OptionLabel_InProgress': 'in Bearbeitung',
    'FORMS.Radio_Label_Company': 'Unternehmen',
    'FORMS.Radio_Label_Subcontractor': 'Subunternehmer',
    'FORMS.Radio_Label_ChoosenCraft': 'Gewähltes Gewerk',
    'FORMS.Radio_Label_AllCrafts': 'Alle Gewerke',
    'FORMS.Checkbox_Label_JobCompleted': 'Job fertiggestellt',
    'FORMS.Checkbox_Label_CraftCompleted': 'Gewerk fertiggestellt',
    'FORMS.Input_Placeholder_Email': 'E-Mail',
    'FORMS.Input_Placeholder_Password': 'Passwort',
    'FORMS.Input_Placeholder_Choose': 'Bitte auswählen',
    'FORMS.Input_Placeholder_LanguageLabel': 'Sprachbezeichnung eingeben',
    'FORMS.Input_Placeholder_LanguageSlug': 'Sprach-Slug eingeben',
    'FORMS.Input_Placeholder_GroupName': 'Gruppennamen eingeben',
    'FORMS.Input_Placeholder_ChooseColor': 'Farbe wählen',
    'FORMS.Input_Placeholder_Where': 'Bitte auswählen',
    'FORMS.Input_Placeholder_ChooseHall': 'Halle auswählen',
    'FORMS.Input_Placeholder_ChooseExhibition': 'Veranstaltung auswählen',
    'FORMS.Input_Placeholder_ChooseStand': 'Stand auswählen',
    'FORMS.Input_Placeholder_DeliveryTime': 'Deadline festlegen',
    'FORMS.Input_Placeholder_AcqstnNumber': 'AKQ eingeben',
    'FORMS.Input_Placeholder_ProaufNumber': 'PROAUF eingeben',
    'FORMS.Input_Placeholder_CorridorNumber': 'Gangnummer',
    'FORMS.Input_Placeholder_BlockNumber': 'Blocknummer',
    'FORMS.Input_Placeholder_StandNumber': 'Standnummer',
    'FORMS.Input_Placeholder_ShelfNumber': 'Regalnummer',
    'FORMS.Input_Placeholder_CadNumber': 'CAD-Nummer',
    'FORMS.Input_Placeholder_ShortDescription': 'Kurzbeschreibung eingeben',
    'FORMS.Input_Placeholder_ChooseStatus': 'Status wählen',
    'FORMS.Input_Placeholder_ChooseType': 'Typ wählen',
    'FORMS.Input_Placeholder_ChooseCraftType': 'Gewerketyp wählen',
    'FORMS.Input_Placeholder_ExhibitionName': 'Veranstaltungsnamen hinzufügen',
    'FORMS.Input_Placeholder_ExhibitionEvent': 'Veranstaltungsname eingeben',
    'FORMS.Input_Placeholder_HallName': 'Hallennamen hinzufügen',
    'FORMS.Input_Placeholder_CraftCompletion': 'Bitte Deadline auswählen',
    'FORMS.Input_Placeholder_SelectDate': 'Bitte auswählen',
    'FORMS.Input_Placeholder_StartDate': 'Anfangsdatum',
    'FORMS.Input_Placeholder_EndDate': 'Endtermin',
    'FORMS.Input_Placeholder_Company': 'Firma',
    'FORMS.Input_Placeholder_SelectStand': 'Stand auswählen',
    'FORMS.Input_Placeholder_SelectGraphicStand': 'Aussteller suchen',
    'FORMS.Input_Placeholder_CompletedAt': 'Fertiggestellt am',
    'FORMS.Input_Placeholder_Exhibitor': 'Aussteller Name',
    'FORMS.Input_Placeholder_CustomShelf': 'Eigenes Regal eingeben',
    'FORMS.Validation_DismantlingDatesRequiredTogether': 'Bitte beide Abbauzeiten eingeben oder beide Felder leer lassen.',
    'FORMS.Validation_DismantlingEndBeforeStart': 'Das Abbauende darf nicht vor dem Abbaubeginn liegen.',
    'SEARCH.Input_Placeholder_User': 'Benutzer suchen',
    'SEARCH.Input_Placeholder_Table_User': 'Namen, E-Mail, Telefonnummer suchen',
    'SEARCH.Input_Placeholder_Subcontractor': 'Subunternehmer suchen',
    'SEARCH.Input_Placeholder_Table_Subcontractor': 'ID, Titel, Nummer suchen',
    'SEARCH.Input_Placeholder_Languages': 'Sprachen suchen',
    'SEARCH.Input_Placeholder_Exhibition': 'Veranstaltungen suchen',
    'SEARCH.Input_Placeholder_Stand': 'Nach Stand suchen',
    'SEARCH.Input_Placeholder_Table_Stand': 'Stand suchen',
    'SEARCH.Input_Placeholder_GlobalStand': 'Aussteller suchen',
    'SEARCH.Input_Placeholder_Table_SearchKeyWords': 'Keywords suchen',
    'SEARCH.Input_Placeholder_MultiSelect': 'Suchen',
    'SEARCH.Input_Placeholder_GraphicStands': 'Aussteller suchen',
    'SEARCH.Input_Placeholder_WarehouseShelves': 'Regal oder Aussteller suchen',
    'SEARCH.Input_Placeholder_FreeShelves': 'Freies Regal suchen',
    'SEARCH.Input_Placeholder_TranslationAiUsage': 'Job-/Kommentarübersetzungen suchen',
    'SEARCH.Input_Placeholder_TranslationAiRequests': 'Job-/Kommentarübersetzungsanfragen suchen',
    'SEARCH.Input_Placeholder_CheckLocation': 'Adresse oder Messeort eingeben',
    'SEARCH.Empty_CheckLocation': 'Keine passenden Adressen oder Veranstaltungsorte gefunden',
    'SEARCH.Error_CheckLocationUnavailable': 'Suche ist voruebergehend nicht verfuegbar. Karte manuell verwenden.',
    'SEARCH.Error_CheckLocationRateLimit': 'Suchlimit erreicht. Karte manuell verwenden oder spaeter erneut versuchen.',
    'ACTIONS.List_Item_Label_StandPlan': 'Standplan',
    'ACTIONS.List_Item_Label_Graphic': 'Grafik',
    'ACTIONS.List_Item_Label_Photo': 'Standfoto',
    'ACTIONS.List_Item_Label_Info': 'Info',
    'ACTIONS.List_Item_Label_HallPlan': 'Hallenplan',
    'ACTIONS.List_Item_Label_Image': 'foto',
    'ACTIONS.List_Item_Label_ShowQRCode': 'QR Code',
    'ACTIONS.List_Item_Label_PrintLabel': 'Etikett drucken',
    'ACTIONS.List_Item_Label_Collected': 'Eingesammelt aber nicht verifiziert',
    'ACTIONS.List_Item_Label_Open': 'Open',
    'ACTIONS.List_Item_Label_Done': 'Verifiziert und eingelagert',
    'ACTIONS.List_Item_Label_Sent': 'Eingesammelt und versendet',
    'ACTIONS.Creating': 'Wird erstellt...',
    'ACTIONS.Create_Graphic_Stand': 'Grafik-Stand erstellen',
    'ACTIONS.Fill_All_Fields': 'Alle Felder ausfüllen',
    'ACTIONS.Create': 'Erstellen',
    'ACTIONS.Return_To_Warehouse': 'Zum Lager zurückkehren',
    'GLOBAL.Button_Text_Save': 'Speichern',
    'GLOBAL.Button_Text_Send': 'Senden',
    'GLOBAL.Button_Text_SaveSend': 'Speichern und Senden',
    'GLOBAL.Button_Text_SaveChanges': 'Änderungen speichern',
    'GLOBAL.Button_Text_UserToGroup': 'Benutzer zur Gruppe hinzufügen',
    'GLOBAL.Button_Text_Update': 'Update',
    'GLOBAL.Button_Text_Reimport': 'Erneut importieren',
    'GLOBAL.Button_Text_Cancel': 'Abbrechen',
    'GLOBAL.Button_Text_Delete': 'Löschen',
    'GLOBAL.Button_Text_Remove': 'Entfernen',
    'GLOBAL.Button_Text_Confirm': 'Bestätigen',
    'GLOBAL.Button_Text_AddFile': 'Datei hinzuzufügen',
    'GLOBAL.Button_Text_UploadFile': 'Datei hochladen',
    'GLOBAL.Button_Text_UserGroup': 'Usergruppe',
    'GLOBAL.Button_Text_Login': 'Login',
    'GLOBAL.Button_Text_BackHome': 'Zurück zur Startseite',
    'GLOBAL.Modal_Text_UserSendPass': 'Neues Passwort wirklich versenden?',
    'GLOBAL.Modal_Text_RemoveText': '{ deleteObjectType } wirklich entfernen?',
    'GLOBAL.Modal_Text_DeleteText': '{ deleteObjectType } wirklich löschen?',
    'GLOBAL.Modal_Text_RemoveFrom': 'aus',
    'GLOBAL.Modal_Text_DeleteHallStands': 'Du löschst eine Halle, welche noch Stände enthält. Bitte weise Diesen zuvor eine andere Halle zu.',
    'GLOBAL.Modal_Text_DeleteHall': 'Halle wirklich löschen?',
    'GLOBAL.Modal_Text_ResetFilters': 'Filter löschen',
    'GLOBAL.Button_Text_ExportCsv': 'exportieren',
    'GLOBAL.Button_Text_ExportExel': 'exportieren excel',
    'GLOBAL.Button_Text_SubcontractorsFile': 'Die Subunternehmer-Datei wird importiert',
    'GLOBAL.Button_Text_DownloadReport': 'Bericht downloaden',
    'GLOBAL.Button_Text_Actions': 'Aktionen',
    'GLOBAL.Button_Text_ImportGraphicList': 'Grafikliste importieren',
    'GLOBAL.Button_Text_CreatePacking': 'Bereitstellung anlegen',
    'GLOBAL.Button_Text_BackExhibitionList': 'zur Bereistellungsliste',
    'GLOBAL.Button_Text_GoToGraphicPackingStands': 'zur bereitstellungsliste',
    'GLOBAL.Button_Text_BackGraphicChoise': 'zurück zur Grafikauswahl',
    'GLOBAL.Button_Text_AvailableStoredGraphics': 'Verfuegbare eingelagerte Grafiken exportieren',
    'GLOBAL.Button_Text_EverStoredGraphics': 'Alle jemals eingelagerten Grafiken exportieren',
    'CHECK_QR.Button_Generate': 'CHECK-IN QR',
    'CHECK_QR.Button_View': 'CHECK-IN QR',
    'CHECK_QR.Button_Update': 'UPDATE CHECK-IN QR',
    'CHECK_QR.Button_Create': 'QR-CODE ERSTELLEN',
    'CHECK_QR.Button_Regenerate': 'QR-CODE NEU ERSTELLEN',
    'CHECK_QR.Confirm_RegenerateTitle': 'Check-in-QR-Code neu erstellen?',
    'CHECK_QR.Confirm_RegenerateText': 'Achtung! Der aktuell ausgedruckte QR-Code funktioniert danach nicht mehr. Alle Mitarbeitenden müssen den neuen Code scannen. Fortfahren?',
    'CHECK_QR.Button_Retry': 'QR-ERSTELLUNG WIEDERHOLEN',
    'CHECK_QR.Tooltip_FillCoordinates': 'Speichern Sie zuerst gültige Check-in-Koordinaten.',
    'CHECK_QR.Modal_Title': 'Exhibition Check-in QR',
    'CHECK_QR.Button_DownloadPng': 'Download PNG',
    'CHECK_QR.Button_DownloadPdf': 'Download PDF',
    'CHECK_QR.Button_Print': 'Drucken',
    'CHECK_QR.Text_GeneratedAt': 'QR-Code erstellt: { date }',
    'CHECK_QR.Text_GenerationDateNotRecorded': 'Erstellungsdatum des QR-Codes nicht erfasst',
    'CHECK_QR.Text_PositionUpdatedAt': 'Standort aktualisiert: { date }',
    'CHECK_QR.LocationInfo_Label': 'QR-Gültigkeit nach Standortänderungen',
    'CHECK_QR.LocationInfo_Hint': 'Der gedruckte QR-Code bleibt bei Änderungen an Koordinaten oder Radius gültig. Eine Neugenerierung ist nicht erforderlich.',
    'CHECK_QR.Text_DateUnavailable': 'Datum nicht verfügbar',
    'CHECK_QR.Text_NoQrUrl': 'Der QR-Code konnte nicht erstellt werden. Versuchen Sie es erneut.',
    'CHECK_QR.Text_PdfError': 'PDF konnte nicht erstellt werden',
    'CHECK_QR.Text_ExportError': 'QR-Poster konnte nicht erstellt werden',
    'GLOBAL.Link_Text_Download': 'Download',
    'GLOBAL.Link_Text_Unassigned': 'nicht zugeordnet',
    'GLOBAL.Link_Text_Assigned': 'Zugeordnet',
    'GLOBAL.Text_NoData': 'Keine Einträge',
    'GLOBAL.Text_Status_Active': 'Aktiv',
    'GLOBAL.Text_Status_Disabled': 'Gesperrt',
    'GLOBAL.Text_Status_InProgress': 'In Bearbeitung',
    'GLOBAL.Text_Status_Completed': 'Fertiggestellt',
    'GLOBAL.Text_Status_Overdue': 'Überfällig',
    'MODAL.Button_Text_Choose': 'Suchen',
    'GLOBAL.Text_Status_ChangePassUser': 'Passwort gesendet von { user } um { dateTime }',
    'GLOBAL.Text_NoAdditionalCrafts': 'Für die ausgewählten Stände gibt es kein zusätzliches Gewerk',
    'GLOBAL.Text_GraphicCount': 'Grafik Anzahl',
    'WAREHOUSE.Label_AmountShelves': 'Regale Anzahl',
    'WAREHOUSE.Label_Occupied': 'Belegt',
    'WAREHOUSE.Label_Empty': 'Frei',
    'WAREHOUSE.Label_FreeShelves': 'Freie Regale',
    'WAREHOUSE.Label_CustomShelf': 'Eigenes Regal',
    'WAREHOUSE.Label_CurrentShelf': 'Aktuelles Regal',
    'WAREHOUSE.Button_Text_ResetShelf': 'Regal zurücksetzen',
    'WAREHOUSE.Button_Text_ResetShelfValue': 'Regal { shelfNumber } zurücksetzen',
    'WAREHOUSE.Text_NoFreeShelves': 'Keine freien Regale gefunden',
    'WAREHOUSE.Text_CustomShelfRequired': 'Regalnummer eingeben.',
    'WAREHOUSE.Text_CustomShelfOccupied': 'Dieses Regal ist bereits belegt.',
    'MODAL.Button_Text_AddExhibition': 'Veranstaltung hinzufügen',
    'MODAL.Button_Text_Stands': 'Stände',
    'MODAL.Button_Text_Crafts': 'Gewerke',
    'MODAL.Button_Text_DeliveryTime': 'Deadline ändern',
    'MODAL.Button_Text_CraftTime': 'Deadline ändern',
    'MODAL.Button_Text_AssignSubcontractors': 'Subunternehmer zuweisen',
    'MODAL.Button_Text_CraftDone': 'Gewerk fertiggestellt',
    'MODAL.Button_Text_CraftInProcess': 'Gewerk in Bearbeitung',
    'MODAL.Button_Text_CraftAdditional': 'Zusätzliches Gewerk erstellen',
    'MODAL.Button_Text_CraftAdditionalEdit': 'Zusätzliches Gewerk bearbeiten',
    'MODAL.Button_Text_CraftDelete': 'Gewerk löschen',
    'MODAL.Button_Text_JobCreate': 'Auftrag erstellen',
    'MODAL.Button_Text_AddUserEvent': 'Benutzer zu Veranstaltung hinzufügen',
    'MODAL.Button_Text_AddPrint': 'Grafik einlagern',
    'FORMS.Button_Text_ApplyFilters': 'Filter anwenden',
    'FORMS.Button_Text_ResetFilters': 'Filter löschen',
    'FORMS.Button_Text_AddKey': 'Neuen Schlüssel hinzufügen',
    'ENTITY.Modal_Title_User': 'Benutzer',
    'ENTITY.Modal_Title_Group': 'Gruppe',
    'ENTITY.Modal_Title_Language': 'Sprache',
    'ENTITY.Modal_Title_ExhibitionStand': 'Messestand',
    'ENTITY.Modal_Title_ExhibitionEvent': 'Veranstaltung',
    'ENTITY.Modal_Title_Exhibition': 'Veranstaltung',
    'ENTITY.Modal_Title_Subcontractor': 'Subunternehmer',
    'ENTITY.Modal_Title_StandKey': 'Standschlüssel',
    'ENTITY.Modal_Title_Stand': 'Stand',
    'ENTITY.Modal_Title_Craft': 'Gewerk',
    'ENTITY.Modal_Title_Job': 'Auftrag',
    'ENTITY.Modal_Title_Furnishing': 'Ausstattung',
    'ENTITY.Modal_Title_Document': 'dokumentieren',
    'ENTITY.Modal_Title_Downloading': 'Warten Sie mit dem Herunterladen der Datei...',
    'ENTITY.Modal_Title_Importing': 'Die Ereignisdatei wird importiert...',
    'ENTITY.Modal_Title_Imported': 'Die Termindatei wurde importiert:',
    'MENUS.Label_Exhibitions': 'Veranstaltungen',
    'MENUS.Label_GlobalStandSearch': 'Globale Standsuche',
    'MENUS.Label_Users': 'Benutzer',
    'MENUS.Label_Subcontractors': 'Subunternehmer',
    'MENUS.Label_StaffManagement': 'Personalverwaltung',
    'MENUS.Label_LastMin': 'Last Minute',
    'MENUS.Label_GraphicStorage': 'Grafiklager',
    'MENUS.Label_GraphicStore': 'Grafik archiv',
    'MENUS.Label_GraphicHandout': 'Grafik auslagern',
    'MENUS.Label_GraphicExhibition': 'Grafik Einlagern',
    'MENUS.Label_GraphicPackings': 'Grafik Bereitstellen',
    'MENUS.Label_GraphicWarehouse': 'Grafik Lager',
    'MENUS.Label_GraphicWarehouseOverview': 'Grafik Lager Übersicht',
    'MENUS.Label_ShelfUtilization': 'Regalbelegung',
    'MENUS.Label_Settings': 'Einstellungen',
    'MENUS.Label_Languages': 'Sprachen',
    'MENUS.Label_TranslationAiUsage': 'KI-Nutzung',
    'MENUS.Label_TranslationAiRequests': 'KI-Anfragen',
    'MENUS_DROP.Label_MyProfile': 'Mein Userprofil',
    'MENUS_DROP.Label_Logout': 'Logout',
    'MENUS_DROP.Label_Edit': 'Bearbeiten',
    'MENUS_DROP.Label_ViewLogs': 'Logs öffnen',
    'MENUS_DROP.Label_ViewKeys': 'Schlüssel Nr.',
    'MENUS_DROP.Label_SendPass': 'Passwort versenden',
    'MENUS_DROP.Label_Delete': 'Löschen',
    'MENUS_DROP.Label_Mark': 'Markieren',
    'MENUS_DROP.Label_InProgress': 'In Bearbeitung',
    'MENUS_DROP.Label_Open': 'Offen',
    'MENUS_DROP.Label_Done': 'Fertiggestellt',
    'MENUS_DROP.Label_Make': 'Machen',
    'MENUS_DROP.Label_Online': 'Online',
    'MENUS_DROP.Label_Offline': 'Offline',
    'MENUS_DROP.Label_UploadHallPlan': 'Hallenplan hochladen',
    'MENUS_DROP.Label_LastMinReport': 'Bericht "Last Minute"',
    'MENUS_DROP.Label_LastMinOrders': 'Last Minute Aufträge',
    'MENUS_DROP.Label_ComplainsReport': 'Bericht "MP Reklamation"',
    'MENUS_DROP.Label_ExhibitorReport': 'Bericht "Aussteller Reklamation"',
    'MENUS_DROP.Label_DamageReport': 'Bericht "kontrollierte Schäden"',
    'MENUS_DROP.Label_DamageReportAll': 'Bericht "alle Schäden"',
    'MENUS_DROP.Label_ElfeOnline': 'ELFE online setzen',
    'MENUS_DROP.Label_ElfeOffline': 'ELFE offline setzen',
    'MENUS_DROP.Label_StandsQrCode': 'Stände QR-Codes',
    'MENUS_DROP.Label_StandsCommentsReport': 'Bericht Kommentare',
    'NAVBAR_PAGES.Label_Overview': 'Übersicht',
    'NAVBAR_PAGES.Label_Logs': 'Logs',
    'NAVBAR_PAGES.Label_Users': 'Benutzer',
    'NAVBAR_PAGES.Label_UserGroups': 'Benutzergruppen',
    'NAVBAR_PAGES.Label_GroupUsers': 'Gruppenmitglieder',
    'NAVBAR_PAGES.Label_Crafts': 'Gewerke',
    'NAVBAR_PAGES.Label_Jobs': 'Jobs',
    'NAVBAR_PAGES.Label_Keys': 'Schlüssel',
    'NAVBAR_PAGES.Label_Stands': 'Stände',
    'NAVBAR_PAGES.Label_Halls': 'Hallen',
    'NAVBAR_PAGES.Label_Documents': 'Dokumente',
    'NAVBAR_PAGES.Label_Furnishings': 'LM Ausstattung',
    'NAVBAR_PAGES.Label_GraphicStorage': 'Grafik Einlagerung',
    'NAVBAR_PAGES.Label_Comments': 'Kommentare',
    'NAVBAR_PAGES.Label_GraphicChoises': 'Grafikauswahl aus Grafiklager',
    'NAVBAR_PAGES.Label_GraphicPackedList': 'Bereitstellungsliste',
    'BREADCRUMBS.Label_Logs': 'Logs',
    'BREADCRUMBS.Label_User': 'Benutzer',
    'BREADCRUMBS.Label_Users': 'Benutzer',
    'BREADCRUMBS.Label_UserGroups': 'Benutzergruppen',
    'BREADCRUMBS.Label_GroupUsers': 'Gruppenmitglieder',
    'BREADCRUMBS.Label_Crafts': 'Gewerke',
    'BREADCRUMBS.Label_Jobs': 'Jobs',
    'BREADCRUMBS.Label_Keys': 'Schlüssel',
    'BREADCRUMBS.Label_Stands': 'Stände',
    'BREADCRUMBS.Label_Halls': 'Hallen',
    'BREADCRUMBS.Label_Exhibitions': 'Veranstaltungen',
    'BREADCRUMBS.Label_GlobalStandSearch': 'Globale Standsuche',
    'BREADCRUMBS.Label_Furnishings': 'Ausstattung',
    'BREADCRUMBS.Label_Subcontractors': 'Subunternehmer',
    'BREADCRUMBS.Label_StaffManagement': 'Personalverwaltung',
    'BREADCRUMBS.Label_LastMin': 'Last Minute',
    'BREADCRUMBS.Label_Create': 'erstellen',
    'BREADCRUMBS.Label_Documents': 'dokumente',
    'BREADCRUMBS.Label_Graphic_Commissioning': 'Grafik Auslagerung',
    'BREADCRUMBS.Label_GraphicChoise': 'Grafikauswahl aus Grafiklager',
    'BREADCRUMBS.Label_GraphicPackedList': 'Bereitstellungsliste',
    'BREADCRUMBS.Label_GraphicStorage': 'Grafik Einlagerung',
    'BREADCRUMBS.Label_GraphicWarehouseOverview': 'Grafik Lager Übersicht',
    'BREADCRUMBS.Label_ShelfUtilization': 'Regalbelegung',
    'BREADCRUMBS.Label_Comments': 'Kommentare',
    'BREADCRUMBS.Label_Settings': 'Einstellungen',
    'BREADCRUMBS.Label_Languages': 'Sprachen',
    'BREADCRUMBS.Label_TranslationAiUsage': 'Job- und Kommentarübersetzungsnutzung',
    'BREADCRUMBS.Label_TranslationAiRequests': 'Job- und Kommentarübersetzungsanfragen',
    'COMMENTS.Button_Text_Add': 'Kommentar hinzufügen',
    'COMMENTS.Button_Text_AddUpper': 'KOMMENTAR HINZUFÜGEN',
    'COMMENTS.Button_Text_Save': 'SAVE',
    'COMMENTS.Button_Text_Export': 'IN DATEI EXPORTIEREN',
    'COMMENTS.Text_NoComments': 'Noch keine Kommentare',
    'COMMENTS.Text_Uploading': 'Wird hochgeladen...',
    'PAGES.Title_Dashboard': 'Dashboard',
    'PAGES.Title_Users': 'Benutzer',
    'PAGES.Title_CreateUser': 'Benutzer erstellen',
    'PAGES.Title_CreateGroupUser': 'Benutzergruppe erstellen',
    'PAGES.Title_UserGroups': 'Benutzergruppen',
    'PAGES.Title_Languages': 'Sprachen',
    'PAGES.Title_CreateLanguage': 'Sprache erstellen',
    'PAGES.Title_EditLanguage': 'Sprache bearbeiten',
    'PAGES.Title_Subcontractors': 'Subunternehmer',
    'PAGES.Title_StaffManagement': 'Personalverwaltung',
    'PAGES.Title_SubcontractorCreate': 'Subunternehmer erstellen',
    'PAGES.Title_CreateStand': 'Stand erstellen',
    'PAGES.Title_LastMinJobs': 'Last Minute Jobs',
    'PAGES.Title_CreateHall': 'Halle erstellen',
    'PAGES.Title_Exhibitions': 'Veranstaltungen',
    'PAGES.Title_GlobalStandSearch': 'Globale Standsuche',
    'PAGES.Title_CreateExhibitions': 'Veranstaltung erstellen',
    'PAGES.Title_CreateExhibitionPacking': 'Grafik Bereitstellung erstellen',
    'PAGES.Title_GraphicCommissioning': 'Grafik Auslagerung',
    'PAGES.Title_CreateGraphicStand': 'Grafik - Bereitstellen',
    'PAGES.Title_TranslationAiUsage': 'Job- und Kommentarübersetzungsnutzung',
    'PAGES.Title_TranslationAiRequests': 'Job- und Kommentarübersetzungsanfragen',
    'PAGES.Text_AllExisting': 'Alle aktiven Last-Minute-Aufträge des Standes',
    'PAGES.Text_NoExisting': 'Es gibt keine aktiven Last-Minute-Aufträge für diesen Stand',
    'PAGES.Title_ShelfUtilization': 'Regalbelegung',
    'PAGES.Text_404': 'Die Seite, die du suchst, existiert leider nicht.',
    'CRAFTS.label_Logistics': 'Logistik { num }',
    'CRAFTS.label_Floor': 'Boden { num }',
    'CRAFTS.label_Assembly': 'Montage { num }',
    'CRAFTS.label_Electrics': 'Elektrik { num }',
    'CRAFTS.label_Graphic': 'Grafik { num }',
    'CRAFTS.label_Furniture': 'Möbel { num }',
    'CRAFTS.label_Multimedia': 'multimedia { num }',
    'CRAFTS.label_Cleaning': 'Reinigung { num }',
    'CRAFTS.label_Additional': 'Sonstiges { num }',
    'CRAFTS.label_MpControl': 'MP Kontroll',
    'CRAFTS.label_Protocol': 'Protokoll',
    'CRAFTS.label_Service': 'Service { num }',
    'CRAFTS.label_CollectGraphics': 'Grafiken sammeln { num }',
    'NOTIFICATIONS.GraphicStandCreated': 'Grafikstand erstellt',
    'NOTIFICATIONS.GraphicStandCreatedDescription': 'Grafikstand wurde erfolgreich aus dem Lager entnommen',
    'STAFF_MANAGEMENT.Column_Exhibition': 'Ausstellung',
    'STAFF_MANAGEMENT.Column_Status': 'Status',
    'STAFF_MANAGEMENT.Column_Construction': 'Aufbau',
    'STAFF_MANAGEMENT.Column_ExhibitionPeriod': 'Ausstellung',
    'STAFF_MANAGEMENT.Column_Dismantling': 'Abbau',
    'STAFF_MANAGEMENT.Column_Workers': 'Mitarbeiter',
    'STAFF_MANAGEMENT.Column_Subcontractors': 'Subunternehmer',
    'STAFF_MANAGEMENT.Filter_SearchExhibition': 'Ausstellung suchen',
    'STAFF_MANAGEMENT.Filter_AllStatuses': 'Alle Status',
    'STAFF_MANAGEMENT.Filter_ConstructionPeriod': 'Aufbauzeitraum',
    'STAFF_MANAGEMENT.Filter_ExhibitionPeriod': 'Ausstellungszeitraum',
    'STAFF_MANAGEMENT.Filter_DismantlingPeriod': 'Abbauzeitraum',
    'STAFF_MANAGEMENT.Status_live': 'Live',
    'STAFF_MANAGEMENT.Status_construction': 'Aufbau',
    'STAFF_MANAGEMENT.Status_upcoming': 'Bevorstehend',
    'STAFF_MANAGEMENT.Status_ready_dismantling': 'Wartet auf Abbau',
    'STAFF_MANAGEMENT.Status_dismantling': 'Abbau läuft',
    'STAFF_MANAGEMENT.Status_past': 'Vergangen',
    'STAFF_MANAGEMENT.Status_unknown': 'Unbekannt',
    'STAFF_MANAGEMENT.Text_OnSite': 'vor Ort',
    'STAFF_MANAGEMENT.Workers_MissedCheckoutOne': '{ count } Mitarbeiter hat sich nicht rechtzeitig ausgecheckt.',
    'STAFF_MANAGEMENT.Workers_MissedCheckoutMany': '{ count } Mitarbeiter haben sich nicht rechtzeitig ausgecheckt.',
    'STAFF_MANAGEMENT.Workers_FailedCheckoutOne': 'Check-out für { count } Mitarbeiter vom System abgelehnt.',
    'STAFF_MANAGEMENT.Workers_FailedCheckoutMany': 'Check-out für { count } Mitarbeiter vom System abgelehnt.',
    'STAFF_MANAGEMENT.Workers_StatusesLoading': 'Mitarbeiterstatus wird geladen',
    'STAFF_MANAGEMENT.Workers_StatusesUnavailable': 'Status nicht verfügbar',
    'STAFF_MANAGEMENT.Text_Subcontractors': 'Subunternehmer',
    'STAFF_MANAGEMENT.Action_CheckInQr': 'Check-in QR',
    'STAFF_MANAGEMENT.Action_NoQr': 'Noch kein QR-Code',
    'STAFF_MANAGEMENT.Action_GenerateQr': 'QR-Code erstellen',
    'STAFF_MANAGEMENT.Action_RegenerateQr': 'QR erneuern',
    'STAFF_MANAGEMENT.Text_RevokeQrPrompt': 'Diesen Code widerrufen?',
    'STAFF_MANAGEMENT.Action_RetryQrGeneration': 'Erneut versuchen',
    'STAFF_MANAGEMENT.Action_ClearAll': 'Alle löschen',
    'STAFF_MANAGEMENT.Action_Retry': 'Erneut versuchen',
    'STAFF_MANAGEMENT.Action_AddGroup': 'Gruppe hinzufügen',
    'STAFF_MANAGEMENT.Tab_CheckInSetup': 'Check-in-Einrichtung',
    'STAFF_MANAGEMENT.Tab_CheckInHistory': 'Änderung der Check In Position',
    'STAFF_MANAGEMENT.History_Description': 'Zeigt, wer die Check-in-Koordinaten, den Radius, das Land oder die Adresse dieser Messe geändert hat, wann die Änderung erfolgte, die Quelle (App oder CRM) sowie die vorherigen und neuen Werte.',
    'STAFF_MANAGEMENT.History_LoadError': 'Der Verlauf der Check-in-Standortänderungen konnte nicht geladen werden.',
    'STAFF_MANAGEMENT.History_Retry': 'Erneut versuchen',
    'STAFF_MANAGEMENT.History_ChangedBy': 'Geändert von',
    'STAFF_MANAGEMENT.History_Source': 'Quelle',
    'STAFF_MANAGEMENT.History_DateTime': 'Datum und Uhrzeit',
    'STAFF_MANAGEMENT.History_ChangedFields': 'Geänderte Felder',
    'STAFF_MANAGEMENT.History_NewPosition': 'Neuer Standort und Radius',
    'STAFF_MANAGEMENT.History_Details': 'Details',
    'STAFF_MANAGEMENT.History_DetailsTitle': 'Änderung des Check-in-Standorts',
    'STAFF_MANAGEMENT.History_Field': 'Feld',
    'STAFF_MANAGEMENT.History_Before': 'Vorher',
    'STAFF_MANAGEMENT.History_After': 'Nachher',
    'STAFF_MANAGEMENT.History_Latitude': 'Breitengrad',
    'STAFF_MANAGEMENT.History_Longitude': 'Längengrad',
    'STAFF_MANAGEMENT.History_Radius': 'Radius',
    'STAFF_MANAGEMENT.History_Country': 'Land',
    'STAFF_MANAGEMENT.History_Address': 'Adresse',
    'STAFF_MANAGEMENT.History_QrGeneratedAt': 'QR-Erstellung',
    'STAFF_MANAGEMENT.History_NoPosition': 'Für diese Änderung wurde kein Standort aufgezeichnet.',
    'STAFF_MANAGEMENT.Tab_Workers': 'Mitarbeiter',
    'STAFF_MANAGEMENT.Tab_Attendance': 'Anwesenheit',
    'STAFF_MANAGEMENT.Tab_AuditLog': 'Audit-Log',
    'STAFF_MANAGEMENT.Action_AttendanceReport': 'Anwesenheitsbericht',
    'STAFF_MANAGEMENT.Action_AuditLogReport': 'Audit-Log-Bericht',
    'STAFF_MANAGEMENT.Section_CheckInLocation': 'Check-in-Standort',
    'STAFF_MANAGEMENT.Provenance_LastSet': 'Zuletzt festgelegt:',
    'STAFF_MANAGEMENT.Provenance_Created': 'Erstellt:',
    'STAFF_MANAGEMENT.Provenance_By': 'von { name }',
    'STAFF_MANAGEMENT.Provenance_FromApp': 'aus der App',
    'STAFF_MANAGEMENT.Provenance_FromCrm': 'aus dem CRM',
    'STAFF_MANAGEMENT.Provenance_Unavailable': 'Nicht verfügbar',
    'STAFF_MANAGEMENT.Section_SetUpCheckIn': 'Check-in einrichten',
    'STAFF_MANAGEMENT.Step_ChooseGroups': '1. Benutzergruppen auswählen, die einchecken müssen',
    'STAFF_MANAGEMENT.Step_SetUpLocation': '2. Check-in-Standort und -Zone einrichten',
    'STAFF_MANAGEMENT.Modal_ChooseGroups': 'Benutzergruppen auswählen, die einchecken müssen',
    'STAFF_MANAGEMENT.Section_CheckInQr': 'Check-in-QR-Code',
    'STAFF_MANAGEMENT.Field_Address': 'Adresse',
    'STAFF_MANAGEMENT.Placeholder_Address': 'Adresse oder Namen des Veranstaltungsortes eingeben',
    'STAFF_MANAGEMENT.Text_DragPin': 'Sie können die Markierung auf der Karte verschieben — die Felder werden automatisch aktualisiert.',
    'STAFF_MANAGEMENT.Text_QrDescription': 'Dieser Code bleibt unverändert, auch wenn Sie den Standort oder Radius ändern.',
    'STAFF_MANAGEMENT.QrState_Generating': 'QR-Code wird erstellt…',
    'STAFF_MANAGEMENT.QrState_Regenerating': 'Ein neuer QR-Code wird erstellt…',
    'STAFF_MANAGEMENT.QrState_GenerationFailed': 'Der Standort wurde gespeichert, aber der QR-Code konnte nicht erstellt werden.',
    'STAFF_MANAGEMENT.QrState_RegenerationFailed': 'Der neue QR-Code konnte nicht erstellt werden. Versuchen Sie es erneut.',
    'STAFF_MANAGEMENT.QrState_Outdated': 'Der Check-in-Standort wurde geändert. Erstellen Sie den QR-Code vor der Verwendung neu.',
    'STAFF_MANAGEMENT.QrState_OutdatedLabel': 'Veraltet',
    'STAFF_MANAGEMENT.QrState_SaveValidLocation': 'Speichern Sie vor der Neuerstellung einen gültigen Check-in-Standort.',
    'STAFF_MANAGEMENT.QrState_SaveValidSetup': 'Speichern Sie einen gültigen Standort und mindestens eine Benutzergruppe vor der Neuerstellung.',
    'STAFF_MANAGEMENT.QrState_NoQrTitle': 'Noch kein QR-Code',
    'STAFF_MANAGEMENT.QrState_NoQrDescription': 'Wählen Sie eine Benutzergruppe und einen Standort aus und klicken Sie auf „Speichern“ — { br }der Code erscheint hier zum Herunterladen oder Drucken.',
    'STAFF_MANAGEMENT.Modal_CheckInQr': 'Check-in-QR-Code',
    'STAFF_MANAGEMENT.Filter_SearchName': 'Nach Namen suchen',
    'STAFF_MANAGEMENT.Filter_SearchWorker': 'Mitarbeiter suchen',
    'STAFF_MANAGEMENT.Filter_SelectPeriod': 'Zeitraum wählen',
    'STAFF_MANAGEMENT.Filter_Subcontractor': 'Subunternehmer',
    'STAFF_MANAGEMENT.Filter_AllSubcontractors': 'Alle Subunternehmer',
    'STAFF_MANAGEMENT.Filter_GroupBy': 'Gruppieren nach',
    'STAFF_MANAGEMENT.Group_Date': 'Datum',
    'STAFF_MANAGEMENT.Group_Subcontractor': 'Subunternehmer',
    'STAFF_MANAGEMENT.Column_Worker': 'Mitarbeiter',
    'STAFF_MANAGEMENT.Column_Subcontractor': 'Subunternehmer',
    'STAFF_MANAGEMENT.Column_Date': 'Datum',
    'STAFF_MANAGEMENT.Column_FirstCheckIn': 'Erster Check-in',
    'STAFF_MANAGEMENT.Column_LastCheckOut': 'Letzter Check-out',
    'STAFF_MANAGEMENT.Column_TotalHours': 'Gesamtstunden',
    'STAFF_MANAGEMENT.WorkersHours_PartialHint': 'Enthält nur abgeschlossene Sitzungen. Einige Sitzungen sind noch offen.',
    'STAFF_MANAGEMENT.WorkersHours_NoCompletedHint': 'Noch keine abgeschlossenen Sitzungen. Einige Sitzungen sind noch offen.',
    'STAFF_MANAGEMENT.WorkersHours_UnavailableHint': 'Für einige abgeschlossene Sitzungen fehlen die Stundenangaben.',
    'STAFF_MANAGEMENT.WorkersHours_UnavailableOpenHint': 'Für einige abgeschlossene Sitzungen fehlen die Stundenangaben. Einige Sitzungen sind noch offen.',
    'STAFF_MANAGEMENT.WorkersAction_ViewSession': 'Sitzung unter Anwesenheit anzeigen',
    'STAFF_MANAGEMENT.WorkersStatus_CheckedIn': 'Eingecheckt',
    'STAFF_MANAGEMENT.WorkersStatus_NotCheckedIn': 'Nicht eingecheckt',
    'STAFF_MANAGEMENT.WorkersStatus_CheckedOut': 'Ausgecheckt',
    'STAFF_MANAGEMENT.Text_WorkersCount': '{ count } Mitarbeiter',
    'STAFF_MANAGEMENT.Text_OneWorker': '1 Mitarbeiter',
    'STAFF_MANAGEMENT.Text_SessionsCount': '{ count } Sitzungen',
    'STAFF_MANAGEMENT.AttendanceStatus_InProgress': 'Mitarbeiter eingecheckt',
    'STAFF_MANAGEMENT.AttendanceStatus_FailedCheckout': 'Check-out fehlgeschlagen',
    'STAFF_MANAGEMENT.AttendanceStatus_MissedCheckout': 'Check-out verpasst',
    'STAFF_MANAGEMENT.Text_Session': 'Sitzung',
    'STAFF_MANAGEMENT.Text_SessionNumber': 'Sitzung { number }',
    'STAFF_MANAGEMENT.Action_ToggleSessionDetails': 'Sitzungsdetails ein- oder ausblenden',
    'STAFF_MANAGEMENT.Action_ManualCheckout': 'Manuell auschecken',
    'STAFF_MANAGEMENT.ManualCheckout_ConfirmTitle': 'Manuellen Check-out bestätigen',
    'STAFF_MANAGEMENT.ManualCheckout_ConfirmText': '{ worker } für die Ausstellung { event } manuell auschecken? Check-in: { checkIn }.',
    'STAFF_MANAGEMENT.ManualCheckout_By': 'Manuell ausgecheckt von { name }',
    'STAFF_MANAGEMENT.AttendanceDetails_CheckInAt': 'Check-in: { dateTime }',
    'STAFF_MANAGEMENT.AttendanceDetails_CheckOutAt': 'Check-out: { dateTime }',
    'STAFF_MANAGEMENT.ManualCheckout_UnknownActor': 'Manueller Check-out — Benutzer nicht angegeben',
    'STAFF_MANAGEMENT.ManualCheckout_Error': 'Der manuelle Check-out konnte nicht abgeschlossen werden.',
    'STAFF_MANAGEMENT.ManualCheckout_RefreshError': 'Der manuelle Check-out war erfolgreich, aber die Anwesenheitsdaten konnten nicht aktualisiert werden. Laden Sie die Seite neu, um die aktuellen Summen zu sehen.',
    'STAFF_MANAGEMENT.ManualCheckout_Success': 'Manueller Check-out abgeschlossen.',
    'STAFF_MANAGEMENT.ManualCheckout_StaleSession': 'Diese Sitzung kann nicht mehr manuell ausgecheckt werden. Aktualisieren Sie die Anwesenheitsdaten.',
    'STAFF_MANAGEMENT.AttendanceDetails_AllScansInsideZone': 'Alle Scans innerhalb der { radius }-m-Zone',
    'STAFF_MANAGEMENT.AttendanceDetails_AllScansInsideZoneUnknownRadius': 'Alle Scans innerhalb der Check-in-Zone',
    'STAFF_MANAGEMENT.AttendanceDetails_CheckoutRejected': 'Check-out abgelehnt — außerhalb der { radius }-m-Zone',
    'STAFF_MANAGEMENT.AttendanceDetails_CheckoutRejectedGeneric': 'Check-out abgelehnt',
    'STAFF_MANAGEMENT.AttendanceDetails_CheckoutRejectedWithReason': 'Check-out abgelehnt — { reason }',
    'STAFF_MANAGEMENT.AttendanceDetails_MissedCheckoutNote': 'Kein Check-out innerhalb von 18 h nach dem Check-in — wahrscheinlich vergessen',
    'STAFF_MANAGEMENT.AttendanceDetails_FailedCheckoutSummary': '{ count } Versuche · { first }–{ last } · zuletzt ca. { distance } m von der Zone entfernt',
    'STAFF_MANAGEMENT.AttendanceWarning_WorkedMoreThanNineHours': 'Mehr als 9 h gearbeitet — länger als eine reguläre Arbeitssitzung.',
    'STAFF_MANAGEMENT.AttendanceWarning_InProgressOverNineHours': 'Seit dem Check-in sind mehr als 9 h vergangen, noch kein Check-out. Nach 18 h wird automatisch als „Check-out verpasst“ geschlossen.',
    'STAFF_MANAGEMENT.Action_ViewMap': 'Karte anzeigen',
    'STAFF_MANAGEMENT.Text_NoLocation': 'Kein Standort',
    'STAFF_MANAGEMENT.ScanModal_Title': 'Scan-Standort',
    'STAFF_MANAGEMENT.ScanModal_Title_OutsideZone': 'Scan außerhalb der Zone',
    'STAFF_MANAGEMENT.ScanModal_Worker': 'Mitarbeiter',
    'STAFF_MANAGEMENT.ScanModal_DateTime': 'Datum und Uhrzeit',
    'STAFF_MANAGEMENT.ScanModal_Distance': 'Entfernung von der Check-in-Zone',
    'STAFF_MANAGEMENT.ScanModal_Location': 'Standort',
    'STAFF_MANAGEMENT.ScanModal_ZoneDescription': 'Check-in-Zone: { latitude }, { longitude }; Radius { radius } m',
    'STAFF_MANAGEMENT.ScanModal_CurrentZoneWarning': 'Historische Zone nicht verfügbar. Der Kreis zeigt die aktuelle Check-in-Zone der Ausstellung, die von der Zone zum Scanzeitpunkt abweichen kann.',
    'STAFF_MANAGEMENT.ScanGuidance_Label': 'Diese GPS-Messung erklären',
    'STAFF_MANAGEMENT.ScanGuidance_Audience_worker': 'Dem Mitarbeiter sagen',
    'STAFF_MANAGEMENT.ScanGuidance_Audience_manager': 'Für den Manager',
    'STAFF_MANAGEMENT.ScanGuidance_Title_missing_accuracy': 'Keine Angaben zur Genauigkeit',
    'STAFF_MANAGEMENT.ScanGuidance_Title_missing_zone': 'Zone zum Scanzeitpunkt fehlt',
    'STAFF_MANAGEMENT.ScanGuidance_Title_missing_distance': 'Entfernung zur Zone unbekannt',
    'STAFF_MANAGEMENT.ScanGuidance_Title_outside': 'Punkt außerhalb der Zone',
    'STAFF_MANAGEMENT.ScanGuidance_Title_inside': 'Punkt innerhalb der Zone',
    'STAFF_MANAGEMENT.ScanGuidance_Title_imprecise': 'Standort ungenau bestimmt',
    'STAFF_MANAGEMENT.ScanGuidance_Title_boundary': 'Punkt nahe der Zonengrenze',
    'STAFF_MANAGEMENT.ScanGuidance_Fact_missing_accuracy': 'Die GPS-Genauigkeit dieses Scans ist nicht bekannt.',
    'STAFF_MANAGEMENT.ScanGuidance_Fact_missing_zone': 'Die Check-in-Zone zum Zeitpunkt dieses Scans wurde nicht gespeichert.',
    'STAFF_MANAGEMENT.ScanGuidance_Fact_missing_distance': 'Die Entfernung zur Check-in-Zone ist für diesen Scan nicht bekannt.',
    'STAFF_MANAGEMENT.ScanGuidance_Fact_outside': 'Das Telefon zeigt einen Standort in { distance } Entfernung vom Check-in-Punkt.',
    'STAFF_MANAGEMENT.ScanGuidance_Fact_inside': 'Der Punkt und der blaue Kreis liegen innerhalb der Check-in-Zone.',
    'STAFF_MANAGEMENT.ScanGuidance_Fact_imprecise': 'Das Telefon hat eine GPS-Genauigkeit von { accuracy } m gemeldet.',
    'STAFF_MANAGEMENT.ScanGuidance_Fact_imprecise_exceeds_zone': 'Das Telefon hat eine GPS-Genauigkeit von { accuracy } m gemeldet, die größer als der Zonenradius ist.',
    'STAFF_MANAGEMENT.ScanGuidance_Fact_boundary_inside': 'Der Punkt liegt innerhalb der Zone, aber der blaue Kreis reicht über ihre Grenze hinaus.',
    'STAFF_MANAGEMENT.ScanGuidance_Fact_boundary_outside': 'Auf der Karte liegt der Punkt { outside } m außerhalb der Zone, bei einer GPS-Genauigkeit von { accuracy } m.',
    'STAFF_MANAGEMENT.ScanGuidance_Fact_boundary_outside_small': 'Auf der Karte liegt der Punkt weniger als 0.1 m außerhalb der Zone, bei einer GPS-Genauigkeit von { accuracy } m.',
    'STAFF_MANAGEMENT.ScanGuidance_Action_accepted': 'Scan akzeptiert. Erneutes Scannen ist nicht nötig.',
    'STAFF_MANAGEMENT.ScanGuidance_Action_retry_center': 'Gehen Sie näher zum Check-in-Punkt, bleiben Sie stehen und scannen Sie den QR-Code erneut.',
    'STAFF_MANAGEMENT.ScanGuidance_Action_retry_entrance': 'Scannen Sie erneut in der Nähe eines offenen Eingangs und bleiben Sie dabei innerhalb der Check-in-Zone.',
    'STAFF_MANAGEMENT.ScanGuidance_Action_verify_location': 'Wo sind Sie gerade? Lassen Sie uns den Check-in-Ort gemeinsam auf der Karte prüfen.',
    'STAFF_MANAGEMENT.ScanGuidance_Action_check_log': 'Prüfen Sie das Ergebnis und den Grund im Audit-Log.',
    'STAFF_MANAGEMENT.Column_ActionType': 'Aktionstyp',
    'STAFF_MANAGEMENT.Column_Result': 'Ergebnis',
    'STAFF_MANAGEMENT.Column_DateTime': 'Datum und Uhrzeit',
    'STAFF_MANAGEMENT.Column_Reason': 'Grund',
    'STAFF_MANAGEMENT.Column_GpsAccuracy': 'GPS-Genauigkeit',
    'STAFF_MANAGEMENT.AuditAccuracy_Hint': 'Vom Gerät geschätzte GPS-Genauigkeit in Metern. Kleinere Werte bedeuten eine höhere Genauigkeit. Die Entfernung zum Check-in-Punkt ist ein separater Wert. Hoch (grün): bis 20 m; Mittel (gelb): über 20 m bis 50 m; Niedrig (rot): über 50 m.',
    'STAFF_MANAGEMENT.AuditAccuracy_good': 'Hoch',
    'STAFF_MANAGEMENT.AuditAccuracy_warning': 'Mittel',
    'STAFF_MANAGEMENT.AuditAccuracy_poor': 'Niedrig',
    'STAFF_MANAGEMENT.AuditAccuracy_unknown': 'Kein GPS',
    'STAFF_MANAGEMENT.Column_Device': 'Gerät',
    'STAFF_MANAGEMENT.Column_ScanLocation': 'Scan-Standort',
    'STAFF_MANAGEMENT.Filter_Result': 'Ergebnis',
    'STAFF_MANAGEMENT.Filter_ActionType': 'Aktionstyp',
    'STAFF_MANAGEMENT.AuditAction_check_in': 'Check-in',
    'STAFF_MANAGEMENT.AuditAction_check_out': 'Check-out',
    'STAFF_MANAGEMENT.AuditAction_unknown': 'Unbekannt',
    'STAFF_MANAGEMENT.AuditResult_accepted': 'Akzeptiert',
    'STAFF_MANAGEMENT.AuditResult_rejected': 'Abgelehnt',
    'STAFF_MANAGEMENT.AuditResult_ignored': 'Ignoriert',
    'STAFF_MANAGEMENT.AuditResult_unknown': 'Unbekannt',
    'STAFF_MANAGEMENT.AuditReason_within_radius': 'Innerhalb des Radius',
    'STAFF_MANAGEMENT.AuditReason_outside_radius': 'Außerhalb des Radius',
    'STAFF_MANAGEMENT.AuditReason_duplicate_scan': 'Bereits eingecheckt',
    'STAFF_MANAGEMENT.AuditReason_AlreadyCheckedIn_Hint': 'Vor einem erneuten Check-in bei dieser Veranstaltung zuerst auschecken.',
    'STAFF_MANAGEMENT.AuditReason_open_session_elsewhere': 'Bei einer anderen Veranstaltung eingecheckt',
    'STAFF_MANAGEMENT.AuditReason_OpenSessionElsewhere_Hint': 'Vor dem Check-in hier zuerst bei der anderen Veranstaltung auschecken.',
    'STAFF_MANAGEMENT.AuditReason_location_permission_denied': 'Standortzugriff verweigert',
    'STAFF_MANAGEMENT.AuditReason_camera_permission_denied': 'Kamerazugriff verweigert',
    'STAFF_MANAGEMENT.AuditReason_outside_schedule': 'Außerhalb des Check-in-Zeitraums',
    'STAFF_MANAGEMENT.AuditReason_location_unavailable': 'Standort nicht verfügbar',
    'STAFF_MANAGEMENT.AuditReason_no_open_session': 'Keine offene Sitzung',
    'STAFF_MANAGEMENT.AuditReason_same_device': 'Dasselbe Telefon wie { worker } verwendet',
    'STAFF_MANAGEMENT.AuditReason_manual_close': 'Manuell ausgecheckt von { name }',
    'STAFF_MANAGEMENT.AuditReason_invalid_qr': 'Falscher Code gescannt',
    'STAFF_MANAGEMENT.AuditReason_outdated_qr': 'Veralteter QR-Code gescannt',
    'STAFF_MANAGEMENT.AuditReason_unknown': 'Unbekannter Grund',
    'STAFF_MANAGEMENT.Action_View': 'Anzeigen',
    'STAFF_MANAGEMENT.Error_LoadEvents': 'Die Ausstellungen der Personalverwaltung konnten nicht geladen werden.',
    'STAFF_MANAGEMENT.Error_LoadWorkerStatuses': 'Der Status der Mitarbeiter konnte nicht geladen werden. Bitte erneut versuchen.',
    'STAFF_MANAGEMENT.Error_LoadWorkers': 'Die Mitarbeiter und ihre Arbeitsstunden konnten nicht geladen werden. Bitte erneut versuchen.',
    'DATE.Time_Zone': 'de-de',
};

export default deutsch;
